<script setup lang="ts">
  import { RouterView, useRoute } from 'vue-router';
  import { defineAsyncComponent, ref, watch, onMounted } from 'vue';
  import { useMenuStore } from "@/store/index";
  import { storeToRefs } from 'pinia';
	import { ResponseMenu, Product } from './models/responseMenu.interface';
	import menuService from '@/services/menu';
	import TrackService from '@/services/track-custom';
	import { useClickEvent } from './helpers/composables';
  import { useLanguage } from './helpers/language-composables';
	import { useI18n } from 'vue-i18n';
  import supplierSurveys from './services/supplier-surveys';
  import { ResponseTypeform } from './models/responseTypeForm.interface';

  const { getLabels } = useLanguage();
  const { findProduct } = useClickEvent();
  const menuStore = useMenuStore();
  const { popup,menuData,productClicked,skeletonLoad,trakingData,customerData,currentSupplier,customerSuppliers,contentPopups,defaultLanguageLocalStorage,profileData,typeFormData,flatSplashScreenCluvi,flagCssCustomObj, allergenPopup } = storeToRefs(menuStore);
  const { trakingNewMenu, setMenu } = menuStore;
  const route = useRoute();
  const { locale } = useI18n({ useScope: "global" });

  const Header = defineAsyncComponent(() => import("@/components/header/Header.vue"));
  const FooterLink = defineAsyncComponent(() => import("@/components/footerLink/FooterLink.vue"));
  const FooterNav = defineAsyncComponent(() => import("@/components/footNav/FootNav.vue"));
  const Modal = defineAsyncComponent(() => import("@/components/modal/Modal.vue"));
  const ProductDetail = defineAsyncComponent(() => import("@/components/productDetail/ProductDetail.vue"));
  // const ModalExit = defineAsyncComponent(()=> import("@/components/modal/ModalExitMenu.vue"));
  const ModalRatingsStar = defineAsyncComponent(()=> import("@/components/modal/ModalRatingsStar.vue"));
  const AlertGlobe = defineAsyncComponent(()=> import("@/components/alert/AlertGlobe.vue"));
  const ModalLang = defineAsyncComponent(()=>import("@/components/modal/ModalLang.vue"));
  const AlertLang = defineAsyncComponent(()=> import("@/components/alert/AlertLan.vue"))
  const MenuOpciones = defineAsyncComponent(() => import("@/components/menuOpciones/MenuOpciones.vue"));
  const buttonRatings = defineAsyncComponent(()=>import("@/components/button/ButtonRatings.vue"));
  const OrganismSplashCluvi = defineAsyncComponent(() => import("@/components/organisms/OrganismSplashCluvi.vue"));

  const displayProduct = ref(false);
  interface AlertGlobeModel {
    messages?: string;
    seconds?: number;
    position?: number;
  };
  let dataArrayAlert = ref<AlertGlobeModel>({});
  let alertGlobeModal = ref<Boolean>(false);
  let langModal = ref<Boolean>(false);
  let alertLangModal = ref<Boolean>(false);
  let menuOptionsModal = ref<Boolean>(false);
  let flatLanguageChange = ref<Boolean>(false);
  let openModalRatingStar = ref<Boolean>(false);
  let floatButtonRate = ref<Boolean>(false);
  let offRate = ref<boolean>(false);
  let letFlatTypeForm = ref<boolean>(false);
  let LanguageCluviOnAdds = ref<boolean>(false);

  watch(defaultLanguageLocalStorage, (valNew,valOld) => {
    if(valOld && (valNew !== valOld)) {
      openAlertLang();
      saveLanguageModalButton(valNew);
    } else {
      closeAlertLang();
    };
  });
  watch(
    () => route.query?.product,
    (newId) => {
      if(newId) {
        var product = findProduct(newId as string);
        productClicked.value = product;
      } else {
        productClicked.value = {} as Product;
        displayProduct.value = false;
      }
    }
  );
  watch(productClicked, (newProductClicked) => {
    displayProduct.value = !!Object.keys(newProductClicked)?.length;
  });
  watch(openModalRatingStar, (val) => {
    if(val) NoScrollBody();
    else scrollBody();
  });

  const checkParamsQueryRoute = () => {
    const supplier_id: number = route.params.supplier_id ?  Number(route.params.supplier_id) : 0;
    const service: string = route.params.service ? route.params.service as string : '';
    const subservice: string = route.params.subservice ? route.params.subservice as string : '';
    const product_id: string = route.query.product ? route.query.product as string : '';
    trakingData.value.supplier_id = supplier_id;
    trakingData.value.service = service;
    trakingData.value.subservice = subservice;
    const lang: string = defaultLanguageLocalStorage.value.toLocaleLowerCase();
    getCssPropertiesFlags();
    getMenu(supplier_id, service, subservice, product_id, lang);
    getActiveTypeForm();
  };
  const menuRequest = async (supplier_id: number, service: string, subservice: string, lang: string, cached: boolean) => {
    if (cached) return menuService.getMenuCache(supplier_id,service,subservice,'en-menu',lang);
    return menuService.getMenuNonCache(supplier_id,service,subservice,'en-menu',lang);
  };
  const menuResponse = async (supplier_id: number, service: string, subservice: string, lang: string) => {
    const menuData: ResponseMenu = (await menuRequest(supplier_id,service,subservice,lang,true)).data;
    if (!menuData.customer.menu_cached) return (await menuRequest(supplier_id, service, subservice, lang, false)).data;
    return menuData;
  }
  const getMenu = async (supplier_id: number, service: string, subservice: string, product_id: string, lang: string, cached: boolean = true) =>  {
    try {
			skeletonLoad.value = true;
      const menuData: ResponseMenu = await menuResponse(supplier_id, service, subservice, lang);
      if (menuData) {
        setInfoMenuAndCurrenci(menuData);
        trakingNewMenu();
      };
      if (product_id) {
        const product = findProduct(product_id);
        document.title = product.label;
        productClicked.value = product;
      };
      flatSplashScreenCluvi.value = false
    } catch (error) {
			skeletonLoad.value = false;
      console.error(error);
      const menuData:ResponseMenu = (await menuService.getMenuNonCache(supplier_id,service,subservice, 'en-menu',lang)).data;
      if (menuData) setInfoMenuAndCurrenci(menuData);
    };
  };
  const setInfoMenuAndCurrenci = (menuData:ResponseMenu) => {
    TrackService.TrackEventCluvi({},'load new menu');
    setMenu(menuData);
    customerData.value = menuData.customer;
    customerData.value.pixel_google_analytics = 'G-VNP5KSNBM7';
    currentSupplier.value = menuData.current_supplier;
    customerSuppliers.value = menuData.customer_suppliers;
    contentPopups.value = menuData.content_popups;
		skeletonLoad.value = false;
    TrackService.load();
    if(!flatLanguageChange.value) setLanguageMenu();
    showButtonFloat();
  };
  const setLanguageMenu = () => {
    LanguageCluviOnAdds.value = menuData.value.cluvi_add_ons.includes('multilanguage');
    if (customerData.value.langs.length === 0) setI18nFileByLang(customerData.value.language);
    if (customerData.value.langs.length) {
      let dataLanguagesArray:string[] = [];
      dataLanguagesArray = dataLanguagesArray.concat(customerData.value.langs);
      dataLanguagesArray = dataLanguagesArray.concat(customerData.value.language);
      const dataArr = new Set(dataLanguagesArray);
      const languagesArr = [...dataArr];
      var languageBrowser = navigator.language.substr(0,2).toLocaleUpperCase();
      let languageFind = languagesArr.find(item => item === languageBrowser);
      if (!defaultLanguageLocalStorage.value && languageFind) {
        defaultLanguageLocalStorage.value = languageFind;
        setI18nFileByLang(defaultLanguageLocalStorage.value);
        if (LanguageCluviOnAdds.value) openAlertGlobe();
      } else if (defaultLanguageLocalStorage.value && languageFind) {
        setI18nFileByLang(defaultLanguageLocalStorage.value);
        if (LanguageCluviOnAdds.value) openAlertGlobe();
      } else if (defaultLanguageLocalStorage.value && !languageFind) {
        setI18nFileByLang(defaultLanguageLocalStorage.value);
        if (LanguageCluviOnAdds.value) langModal.value = true;
      } else {
        defaultLanguageLocalStorage.value = customerData.value.language;
        setI18nFileByLang(defaultLanguageLocalStorage.value);
        if (LanguageCluviOnAdds.value) langModal.value = true;
      };
    };
  };
	const setI18nFileByLang = (language: string) => {
    locale.value = language.toLocaleLowerCase();
    defaultLanguageLocalStorage.value = language;
  };
  const setDataArrayAlertGlobe = () => {
    dataArrayAlert.value = {
      messages: getLabels('LANGUAGE.ALERTLANGUAGEBROWSER'),
      seconds: 20000,
      position: 0
    };
  };
  const closeModalLang = () => {
    langModal.value = false;
  };
  const saveLanguageModalButton = (lang: string) => {
    defaultLanguageLocalStorage.value = lang;
    flatLanguageChange.value = true;
    checkParamsQueryRoute();
    setTimeout(() => {
      menuOptionsCloseModal();
      closeModalLang();
    }, 2000);
  };
  const openAlertLang = () => {
    setDataArrayAlertLang();
    alertLangModal.value = true;
    setTimeout(() => closeAlertLang(), dataArrayAlert.value.seconds);
  };
  const closeAlertLang = () => {
    alertLangModal.value = false;
  };
  const setDataArrayAlertLang = () => {
    dataArrayAlert.value = {
      messages: getLabels('LANGUAGE.ALERTLANGLABEL'),
      seconds: 30000,
      position: 0
    };
  };
  const menuOptionsOpenModal = () => {
    menuOptionsModal.value = true;
  };
  const menuOptionsCloseModal = () => {
    menuOptionsModal.value = false;
  };
  const openAlertGlobe = () => {
    setDataArrayAlertGlobe();
    alertGlobeModal.value = true;
    setTimeout(() => closeAlertGlobe(), dataArrayAlert.value.seconds);
  };
  const closeAlertGlobe = () => {
    alertGlobeModal.value = false;
  }
  const openModalRate = () => {
    openModalRatingStar.value = true;
    menuOptionsCloseModal();
  };
  const closeModalRatingsStar = () => {
    openModalRatingStar.value = false;
  };
  const NoScrollBody = () => {
    document.body.classList.add('no-scroll');
  };
  const scrollBody = () => {
    document.body.classList.remove('no-scroll');
  };
  const hiddenButtonFloat = () => {
    floatButtonRate.value = false;
  };
  const showButtonFloat = () => {
    if (customerData.value.rate_nps === false && customerData.value.rate_digitalmenu === false) {
      floatButtonRate.value = false;
    } else {
      TrackService.TrackEventCluvi({},'has rate');
      setTimeout(() => {
        floatButtonRate.value = flagCssCustomObj.value.flagFloatingButtonSurvey ? true : false;
      }, 5000);
    }
  };
  const getTypesForm = async (supplier_id:number) => {
    try {
      const responseTypeForm:ResponseTypeform = (await supplierSurveys.getSupplierSurveys(supplier_id)).data;
      if (responseTypeForm) {
        letFlatTypeForm.value = true;
        typeFormData.value = responseTypeForm as any;
      };
    } catch (error) {
      console.error(error);
    };
  };
  const getActiveTypeForm = async() => {
    const supplier_id: number = route.params.supplier_id ?  Number(route.params.supplier_id) : 0;
    try {
      const responseActivesForms = (await supplierSurveys.getSupplierSurveysHideRate(supplier_id)).data;
      if (responseActivesForms && !letFlatTypeForm.value) getTypesForm(supplier_id);
    } catch (error) {
      offRate.value = true;
      floatButtonRate.value = false;
      console.error(error);
    };
  };
  const getCssPropertiesFlags = () => {
    const supplierId = currentSupplier.value.id ? currentSupplier.value.id : Number(route.params.supplier_id);
    menuService.getCssProperties(supplierId)
      .then(response => {
        const responseFlagCssCustom = response.data;
        Object.assign(flagCssCustomObj.value, responseFlagCssCustom);
        if(!flagCssCustomObj.value.flagAllergenPopup){
          allergenPopup.value.show = false;
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  onMounted(() => {
    checkParamsQueryRoute();
		trakingNewMenu();
    setTimeout(() => flatSplashScreenCluvi.value = false, 5000);
  });

  flatSplashScreenCluvi.value = true;
</script>

<template>
    <OrganismSplashCluvi v-if="flatSplashScreenCluvi"></OrganismSplashCluvi>
    <div v-else>
      <Header />
      <div class="wrapShift wrapShift-fixed">
        <RouterView />
      </div>
      <FooterLink />
      <ModalLang
        v-if="langModal"
        :customerData="customerData" :defaultLanguageLocalStorage="defaultLanguageLocalStorage"
        @setI18nFileByLang="setI18nFileByLang"
        @closeModalLang="closeModalLang"
      />
      <AlertGlobe v-if="alertGlobeModal" :dataArrayAlert="dataArrayAlert" :locale="(locale as string)" @click="closeAlertGlobe()"/>
      <AlertLang
        v-if="alertLangModal"
        :dataArrayAlert="dataArrayAlert" :locale="(locale as string)" :customerData="customerData"
        @closeAlertLang="closeAlertLang"
      />
      <MenuOpciones
        v-if="menuOptionsModal"
        :menuData="menuData" :defaultLanguageLocalStorage="defaultLanguageLocalStorage" :offRate="offRate"
        @menuOptionsCloseModal="menuOptionsCloseModal"
        @setI18nFileByLang="setI18nFileByLang"
        @saveLanguageModalButton="saveLanguageModalButton"
      />
      <buttonRatings v-if="floatButtonRate" @openModalRate="openModalRate" @hiddenButtonFloat="hiddenButtonFloat" />
      <!-- <FooterNav :offRate="offRate" @menuOptionsOpenModal="menuOptionsOpenModal" /> -->
      <Modal v-if="menuData.upselling_products?.length ||  menuData.content_popups?.length" />
      <Transition enter-active-class="slideInRight" leave-active-class="slideOutRight">
        <ProductDetail v-if="displayProduct"/>
      </Transition>
      <!-- <ModalExit v-if="openModalExit" /> -->
      <ModalRatingsStar
        v-if="openModalRatingStar"
        :customerData="customerData" :profileData="profileData" :trakingData="trakingData"
        @closeModalRatingsStar="closeModalRatingsStar" @hiddenButtonFloat="hiddenButtonFloat"
      />
    </div>
</template>